import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatedMark } from './AnimatedMark';

export const Footer = () => {
  return (
    <footer
      className="relative border-t"
      style={{ background: 'var(--ink)', borderColor: 'var(--line)' }}
    >
      <div className="max-w-[1160px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <AnimatedMark size={44} idPrefix="footer" />
              <div style={{ fontFamily: 'var(--display)', fontWeight: 800, fontSize: 18, color: 'var(--text)' }}>
                Solidcore Venture
              </div>
            </div>
            <p style={{ color: 'var(--muted)', fontSize: 15, maxWidth: 300 }}>
              Built around customers, not clicks.
            </p>
          </div>

          {/* Links */}
          <div>
            <div className="font-mono text-xs uppercase mb-4" style={{ color: 'var(--dim)', letterSpacing: '0.14em' }}>
              Explore
            </div>
            <ul className="space-y-2.5" style={{ color: 'var(--muted)' }}>
              <li><a href="/#approach" className="hover:text-white transition-colors">Approach</a></li>
              <li><a href="/#creator-backend" className="hover:text-white transition-colors">Creator Backend</a></li>
              <li><a href="/#founder" className="hover:text-white transition-colors">Founder</a></li>
              <li><a href="/#contact" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="font-mono text-xs uppercase mb-4" style={{ color: 'var(--dim)', letterSpacing: '0.14em' }}>
              Contact
            </div>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="mailto:kuzagra@solidcoreventure.com"
                  className="hover:text-white transition-colors"
                  style={{ color: 'var(--muted)' }}
                  data-testid="footer-email-link"
                >
                  kuzagra@solidcoreventure.com
                </a>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-white transition-colors"
                  style={{ color: 'var(--dim)', fontSize: 14 }}
                >
                  Services
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Details disclosure — accessible, keyboard-navigable, not prominent */}
        <details
          className="mb-10 rounded-xl group"
          style={{ border: '1px solid var(--line)', background: 'rgba(255,255,255,0.015)' }}
          data-testid="footer-legal-disclosure"
        >
          <summary
            className="cursor-pointer select-none px-5 py-3.5 font-mono uppercase transition-colors hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2"
            style={{
              fontSize: 11,
              letterSpacing: '0.14em',
              color: 'var(--dim)',
              listStyle: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              outlineColor: 'var(--gold)',
            }}
          >
            <span
              className="transition-transform group-open:rotate-90 inline-block"
              style={{ color: 'var(--gold)', fontSize: 10 }}
              aria-hidden="true"
            >
              ▸
            </span>
            Legal Details
          </summary>
          <div
            className="px-5 pb-5 pt-1 space-y-2"
            style={{ fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.7 }}
          >
            <p><b style={{ color: 'var(--text)', fontWeight: 600 }}>Legal Entity:</b> SOLIDCORE VENTURE LLP</p>
            <p><b style={{ color: 'var(--text)', fontWeight: 600 }}>LLPIN:</b> ACY-0585</p>
            <p><b style={{ color: 'var(--text)', fontWeight: 600 }}>Legal Status:</b> Registered Limited Liability Partnership, India.</p>
            <p>
              <b style={{ color: 'var(--text)', fontWeight: 600 }}>Registered Office:</b>{' '}
              Flat No. AMN0101104, 11th Floor, Tower N-10, Jaypee Aman, Sector 151, Noida, Gautam Buddha Nagar, Uttar Pradesh, India – 201301.
            </p>
            <p>
              <b style={{ color: 'var(--text)', fontWeight: 600 }}>Official Contact:</b>{' '}
              <a href="mailto:kuzagra@solidcoreventure.com" className="hover:text-white transition-colors" style={{ color: 'var(--muted)' }}>
                kuzagra@solidcoreventure.com
              </a>
            </p>
          </div>
        </details>

        {/* Bottom strip */}
        <div
          className="pt-8 border-t flex flex-wrap items-center justify-between gap-x-6 gap-y-4"
          style={{ borderColor: 'var(--line)' }}
        >
          <div style={{ fontSize: 13, color: 'var(--dim)', lineHeight: 1.7 }}>
            <div>© 2026 SOLIDCORE VENTURE LLP · LLPIN: ACY-0585</div>
            <div>Registered in India with limited liability.</div>
          </div>

          <div className="flex items-center gap-5" style={{ fontSize: 13.5 }}>
            <Link
              to="/privacy-policy"
              className="hover:text-white transition-colors"
              style={{ color: 'var(--muted)' }}
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <span style={{ color: 'var(--dim)' }} aria-hidden="true">|</span>
            <Link
              to="/legal"
              className="hover:text-white transition-colors"
              style={{ color: 'var(--muted)' }}
              data-testid="footer-legal-link"
            >
              Legal Information
            </Link>
          </div>

          <div className="text-xs font-mono uppercase" style={{ color: 'var(--dim)', letterSpacing: '0.14em' }}>
            Offer · Message · Ads · Funnel · Follow-up · Sales
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
